import { useLayoutEffect, useState } from 'react';
import {
  getTileLoadProgress,
  subscribeTileLoadProgress,
} from '../utils/tileLoadProgress';
import type { TileLoadSnapshot } from '../utils/tileLoadProgress';

export const useTileLoadProgress = (): TileLoadSnapshot => {
  const [snapshot, setSnapshot] = useState(getTileLoadProgress);

  useLayoutEffect(() => {
    setSnapshot(getTileLoadProgress());
    return subscribeTileLoadProgress(() => {
      setSnapshot(getTileLoadProgress());
    });
  }, []);

  return snapshot;
};
